export default __webpack_public_path__ + "8e117f3.png";